import { createContext, useContext } from 'react';

export const PermissionsContext = createContext([]);
export const PermissionsLoadingContext = createContext(true);

export const usePermissions = () => useContext(PermissionsContext);
export const usePermissionsLoading = () => useContext(PermissionsLoadingContext);
